import React from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';

const Forbidden = () => {
  const history = useHistory();

  return (
    <Result
      status="403"
      title="403"
      subTitle="Lo sentimos, no tiene permisos para acceder a esta página."
      extra={
        <Button type="primary" onClick={() => history.push('/')}>
          Volver al Inicio
        </Button>
      }
    />
  );
};

export default Forbidden;
